<template>
  <a :ref="'ftBox-' + template.FtGuid" :class="classes" href="javascript:" :style="{ cursor: (this.options || {}).enableBoxLink ? 'pointer' : 'default' }" @click="gotoDetails()">
    <div class="arrow"></div>
    <div class="item">
      <div class="text">
        <p :title="template.FtName"><strong>{{ template.FtName }}</strong></p>
        <p :title="template.FtFilterFrom + '-' + template.FtFilterTo">{{ template.FtFilterFrom }} - {{ template.FtFilterTo }} cm</p>
      </div>
    </div>
  </a>
</template>
<script>
export default {
  name: 'gaugingTubesBox',
  props: ['template', 'functions', 'options'],
  data() {
    return {
      classes: 'contents',
      isActive: false
    }
  },
  watch: {
    '$route.params.FtID': {
      handler: function (val) {
        if (!val) {
          this.classes = 'contents'
          return
        }
        this.isActive = val === this.template.FtID
        this.classes = this.isActive ? 'contents active' : 'contents'
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    if (this.isActive) {
      this.$nextTick(() => this.$refs['ftBox-' + this.template.FtGuid].scrollIntoView({ behavior: 'smooth', block: 'center' }))
    }
  },

  updated() {
    if (this.isActive) {
      this.$nextTick(() => this.$refs['ftBox-' + this.template.FtGuid].scrollIntoView({ behavior: 'smooth', block: 'center' }))
    }
  },

  methods: {
    gotoDetails() {
      let prid = this.$route.params.projectId
      let mpguid = this.options.MpGuid || this.$route.params.measurementPointId
      let ftid = this.template.FtID
      this.detailUrl = `/project/${prid}/measurementPoint/${mpguid}/gaugingTubes/${ftid}`
      if ((this.options || {}).enableBoxLink) {
        this.$router.push(this.detailUrl)
      }
    }
  }
}
</script>
